import React from 'react'
import '../stylesheets/components/hero.css'
export default class Hero extends React.Component {
  render() {
    return (
      <div className="Hero-cont">
        <div className="Hero1">design.</div>
        <div className="Hero2">inspired</div>
        <div className="hero"> </div>
      </div>
    )
  }
}
